import React from 'react';
import { Cta, Eyebrow, Heading, Reveal, Section } from './primitives';

// Ritual marks already ship with the app's onboarding.
const RITUALS = [
  { title: 'Morning Intentions', body: 'Start your day with the right mindset.', logo: 'morning' },
  { title: 'Shadow Work', body: 'Work through emotions and limiting patterns.', logo: 'shadow' },
  { title: 'Vision Quest', body: "Visualize the future you're building.", logo: 'vision' },
  { title: 'Night Reflections', body: 'Reflect, practice gratitude and release the day.', logo: 'night' },
];

const BARS = Array.from({ length: 28 }, (_, i) => 30 + Math.round(Math.abs(Math.sin(i * 1.7)) * 70));

export default function Rituals({ variant }) {
  return (
    <Section>
      <Reveal className="text-center">
        <Eyebrow>One system</Eyebrow>
        <Heading lines={['Four moments', 'that matter.']} className="text-3xl md:text-5xl" />
      </Reveal>

      <div className="mt-12 grid gap-4 sm:grid-cols-2">
        {RITUALS.map((r, i) => (
          <Reveal key={r.title} delay={i * 0.07}>
            <article className="glass-card flex h-full items-start gap-4 p-6">
              <img
                src={`/brand/rituals/${r.logo}.webp`}
                alt=""
                loading="lazy"
                className="h-12 w-12 shrink-0 rounded-full object-cover"
              />
              <div>
                <h3 className="font-jakarta text-lg font-medium text-white">{r.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-white/60">{r.body}</p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-20 text-center">
        <Eyebrow>And it gets personal</Eyebrow>
        <p className="font-jakarta text-2xl font-light text-white md:text-3xl">Record your voice once.</p>
        <p className="mx-auto mt-3 max-w-lg text-white/70">
          DepthMe can guide your personalized rituals{' '}
          <span className="font-jakarta text-xl italic text-gradient-gold">in your own voice.</span>
        </p>
        <div aria-hidden className="mx-auto mt-10 flex h-20 max-w-sm items-center justify-center gap-[5px]">
          {BARS.map((h, i) => (
            <span
              key={i}
              className="dm-wave-bar w-[4px] rounded-full bg-gradient-to-t from-[#6B21A8] to-[#F5A623]"
              style={{ height: `${h}%`, animationDelay: `${i * 70}ms` }}
            />
          ))}
        </div>
        <p className="mt-8 font-jakarta text-2xl italic text-white/80">
          Your mind. Your journey. Your voice.
        </p>
        <div className="mt-10">
          <Cta variant={variant}>Try my first ritual</Cta>
        </div>
      </Reveal>
    </Section>
  );
}
